import { render, staticRenderFns } from "./AkbsWageBulkTable.vue?vue&type=template&id=2375a275&scoped=true&"
import script from "./AkbsWageBulkTable.vue?vue&type=script&lang=js&"
export * from "./AkbsWageBulkTable.vue?vue&type=script&lang=js&"
import style0 from "./AkbsWageBulkTable.vue?vue&type=style&index=0&id=2375a275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375a275",
  null
  
)

export default component.exports